var render, staticRenderFns
import script from "./VideoPlayPauseBtn.vue?vue&type=script&lang=js&"
export * from "./VideoPlayPauseBtn.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayPauseBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588aa575')) {
      api.createRecord('588aa575', component.options)
    } else {
      api.reload('588aa575', component.options)
    }
    
  }
}
component.options.__file = "src/components/VideoPlayPauseBtn.vue"
export default component.exports